"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconSmileyVeryHappy = function IconSmileyVeryHappy(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '24px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 24 24",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M8 8a2 2 0 1 1-4 0 2 2 0 0 1 4 0m12 0a2 2 0 1 1-4 0 2 2 0 0 1 4 0m-7.974 12.039c-5.069.021-7.47-2.116-8.45-3.964-.413-.778-.574-1.504-.576-1.998l2-.008 14-.06L21 14c.002.493-.153 1.221-.558 2.002-.965 1.857-3.348 4.015-8.416 4.037m-.009-2c-3.286.014-5.061-.974-6.003-1.975l11.99-.051c-.934 1.008-2.7 2.011-5.987 2.025",
    clipRule: "evenodd"
  })));
};

export { IconSmileyVeryHappy, IconSmileyVeryHappy as default };
